'use client';

import { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { SingleOrder } from '../../Orders.functions';
import CreateEditDialog from './CreateEditDialog';
import {
  FormValues,
  attributesTabFields,
  ordererTabFields,
  recipientTabFields,
  senderTabFields,
  values,
} from './CreateEditDialog.functions';
import { GroupOrderConfig } from './GroupOrderConfig';

type Props = {
  reload: () => void;
  onHide: () => void;
  data?: SingleOrder;
  visible: boolean;
  isSmallScreen: boolean;
};

export function GroupOrderDialog({
  reload,
  onHide,
  data,
  visible,
  isSmallScreen,
}: Props) {
  const [orderIndex, setOrderIndex] = useState(0);
  const [orderData, setOrderData] = useState<FormValues[]>([]);
  const [isConfigVisible, setIsConfigVisible] = useState(true);
  console.log(data);
  const methods = useForm<any>({
    defaultValues: {
      isSenderConstant: false,
      isRecipientConstant: false,
      isOrdererConstant: false,
      isAttributesConstant: false,
    },
  });

  const { watch } = methods;
  const formValues = watch();

  useEffect(() => {
    setOrderIndex(0);
    setOrderData([values]);
    setIsConfigVisible(true);
  }, [visible]);

  useEffect(() => {
    setOrderData((orderData) => {
      let newOrderData = [...orderData];
      const constantFields = formValues;
      const firstOrder = orderData[0];

      let initialValues = {
        ...firstOrder,
        ...(!constantFields?.isSenderConstant ? senderTabFields : {}),
        ...(!constantFields?.isRecipientConstant ? recipientTabFields : {}),
        ...(!constantFields?.isOrdererConstant ? ordererTabFields : {}),
        ...(!constantFields?.isAttributesConstant ? attributesTabFields : {}),
        seriski_broj: undefined,
      };

      if (orderIndex >= orderData.length) {
        newOrderData[orderIndex] = initialValues;
      }

      return newOrderData;
    });
  }, [orderIndex]);

  function setOrder(value: any) {
    setOrderData((orderData) => {
      let newOrderData = [...orderData];
      newOrderData[orderIndex] = value;
      return newOrderData;
    });
  }
  console.log('orderData ', orderData);
  return (
    <>
      <FormProvider {...methods}>
        <form id="group-order-create-edit" onSubmit={() => {}}>
          <GroupOrderConfig
            visible={visible && isConfigVisible}
            onHide={onHide}
            onStart={() => setIsConfigVisible(false)}
          />
        </form>
      </FormProvider>

      <CreateEditDialog
        visible={visible && !isConfigVisible}
        isGroupDialog
        orderData={orderData}
        setOrderData={setOrder}
        orderIndex={orderIndex}
        setOrderIndex={setOrderIndex}
        reload={reload}
        onHide={onHide}
        constantFields={formValues}
        isSmallScreen={isSmallScreen}
      />
    </>
  );
}
